import {
    DIC
} from '@/const/dic'
import {
    formatterTime
} from '@/util/util'

export const agentOrderManagementOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    menuWidth: '300',
    columnBtn: false,
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: '订单编号',
            prop: 'orderNumber',
            span: 24,
            search: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: '下单商户名称',
            prop: 'shopName',
            search: true,
            span: 24,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "下单商户账号",
            prop: "account",
            search: true,
            span: 24,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "法人姓名",
            prop: "name",
            type: "input",
            search: false,
            addVisdiplay: false,
            editVisdiplay: false
        },
       /*  {
            label: "商品名称",
            prop: "productName",
            type: "input",
            hide: true,
            formatter: function (row) {
                let a = row.productName
                let arr = a.split(',')
                for (let i of arr) {
                    if (i.length > 10) {
                        i = i.slice(0, 9) + ".."
                        return i
                    }
                }
                return arr.join("</br>")
            },
            addVisdiplay: false,
            editVisdiplay: false
        }, */
        {
            label: "支付方式",
            prop: "payWay",
            dicData: DIC.WALLET_RECHARGE_WAY,
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },

        {
            label: "总数量",
            prop: "total",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "总金额",
            prop: "totalAmount",
            type: 'input',
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "下单时间",
            prop: "createTime",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, column, cellValue) {
                return formatterTime(cellValue)
            }
        },
        {
            label: "配送商",
            prop: "providerShopName",
            type: "input",
            search: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "配送商账号",
            prop: "providerAccount",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "订单状态",
            prop: "status",
            type: "input",
            dicData: DIC.ORDER_MANGEMENT_STATUS,
            addVisdiplay: false,
            editVisdiplay: false
        },
    ]
};